import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const ReportCustomEmailProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const createRecordSidesVolume = useCallback(async (props) => {
        await execute({ scope: 'create', url: `ReportCustomEmail/SidesAndVolume/`, method: 'POST', payload: props, secure: true });
    }, [execute]);


    const value = { data, clearData, createRecordSidesVolume };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useReportCustomEmailProviderStore = () => React.useContext(Context);
